import React from "react";
import { ListButton, SaveButton, Toolbar } from "react-admin";

const StaffUserFormToolbar = (props) => {
  const location = props.location.pathname.split('/')
    const path = location[location.length - 1]
  return (
    <Toolbar {...props} id="toolbar-flex-end">
      <SaveButton onSave={props.onSuccess} className="save-button" />
      <ListButton className="cancel-button" color="default"  label="Cancel">
        <div>Cancel</div>
      </ListButton>
    </Toolbar>
  );
};
export default StaffUserFormToolbar;
